module.exports = __webpack_public_path__ + "assets/stars-background.c99fcd70ce1e737f6640b0add9dbd4e8.png";


//////////////////
// WEBPACK FOOTER
// ../static/images/stars-background.png
// module id = 441
// module chunks = 0